import { render, staticRenderFns } from "./DetailLevel.vue?vue&type=template&id=17895f4d&scoped=true"
import script from "./DetailLevel.vue?vue&type=script&lang=js"
export * from "./DetailLevel.vue?vue&type=script&lang=js"
import style0 from "./DetailLevel.vue?vue&type=style&index=0&id=17895f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17895f4d",
  null
  
)

export default component.exports